'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './add-journal-entry.routes';

export class AddJournalEntryComponent {
  constructor(SettingsService, Auth, $state, dialogs, AccountingService, $uibModal) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.AccountingService = AccountingService;
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$state = $state;
    this.flattedAccountsEnum = [];
    this.flattedAccountsMap = [];
    this.rules = [];
    this.rulesEnum = [];

    this.SettingsService.getByName({name: "chart-of-accounts"}, coa => {
      this.coa = coa.data;

      this.coa.forEach(headAccount => {
        this.flattedAccountsEnum.push(headAccount.account);
        this.flattedAccountsMap.push({ value: headAccount.account, name: headAccount.account});

        if (headAccount.hasOwnProperty('subAccounts')) {
          headAccount.subAccounts.forEach(subAccount => {

            let accounts = [headAccount.account, subAccount.account].join(':');

            this.flattedAccountsEnum.push(accounts);
            this.flattedAccountsMap.push({ value: accounts, name: accounts.split(':').join(' / ')});

            if (subAccount.hasOwnProperty('subAccounts')) {
              subAccount.subAccounts.forEach(subSubAccount => {

                let accounts = [headAccount.account, subAccount.account, subSubAccount.account].join(':');

                this.flattedAccountsEnum.push(accounts);
                this.flattedAccountsMap.push({ value: accounts, name: accounts.split(':').join(' / ')});
              });
            }
          });
        }
      });

      this.SettingsService.getByName({name: 'accounting-rules'}, rules => {

        this.rules = rules.data;
        this.rulesEnum = rules.data.map(code => code.name);

        this.model = {
            entry: "",
            debit: [
              {
                account: '',
                amount: 0
              }
            ],
            credit: [
              {
                account: '',
                amount: 0
              }
            ]
        };
      }, err => {
        console.log('Could not load settings from server');
      });

    }, err => {
      console.log('Could not load settings from server');
    });
  }

  removeDebitAccount(idx) {
    this.model.debit.splice(idx,1);
  }
  removeCreditAccount(idx) {
    this.model.credit.splice(idx,1);
  }
  addDebitAccount() {
    this.model.debit.push({
      account: '',
      amount: 0
    });
  }
  addCreditAccount() {
    this.model.credit.push({
      account: '',
      amount: 0
    });
  }

  accountingRuleChanged () {
      let oRule = this.rules.find(rule => rule.name == this.selectedAccountingRule);

      if (!oRule)
        return;

      this.model.debit = [];
      this.model.credit = [];

      oRule.accounts.debit.forEach(debitAcc => {
      this.model.debit.push({
        account: debitAcc,
        amount: 0
      })
    });

    oRule.accounts.credit.forEach(creditAcc => {
      this.model.credit.push({
        account: creditAcc,
        amount: 0
      })
    });
  }

  lookupAccount(style, type, idx) {
    var that = this;

    let component = 'accountLookup';

    if (style == 'tree')
      component = 'accountTree';


    var modalInstance = this.$uibModal.open({
      animation: true,
      component: component,
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (selectedAccount) {
        that.model[type][idx].account = selectedAccount.accounts;
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    let entry = {
      entry: this.model.entry,
      transactions: []
    };

    this.model.debit.forEach(debit => {
      entry.transactions.push({
        type: 'debit',
        account: debit.account,
        amount: debit.amount
      });
    });

    this.model.credit.forEach(credit => {
      entry.transactions.push({
        type: 'credit',
        account: credit.account,
        amount: credit.amount
      });
    });

    console.log(entry);

    this.AccountingService.entry({book: 'test'}, entry, data => {
      this.model = data;
    });
/*
    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The client settings have been changed successfully");
        dlg.result.then(() => {
          that.$state.go("home");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.settings.data = this.model;

      this.SettingsService.update({id: this.settings._id}, this.settings, onSuccess, onError);
    }
    */
  }
}

export default angular.module('conduu.addJournalEntry', [uiRouter])
  .config(routes)
  .component('addJournalEntry', {
    template: require('./add-journal-entry.html'),
    controller: AddJournalEntryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/accounting/add-journal-entry/add-journal-entry.component.js